import { render } from "./SolicitudCompletada.vue?vue&type=template&id=0b6e3ed8&scoped=true"
const script = {}

import "./SolicitudCompletada.vue?vue&type=style&index=0&id=0b6e3ed8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6e3ed8"]])

export default __exports__